export function safeErrorCode(error: unknown): string {
  try {
    if (typeof error !== "object" || error === null || !("code" in error)) return "unknown";
    const code = error.code;
    return typeof code === "string" && /^(?:[A-Z0-9]{5}|PGRST[0-9]{3})$/.test(code)
      ? code
      : "unknown";
  } catch {
    return "unknown";
  }
}
